// extracted by mini-css-extract-plugin
export default {"wrapper":"Menu_wrapper__rKnhQ"};